<template>
  <div>
    <div class="vg-button-group padding">
      <slot></slot>
    </div>
    <div class="vg-button-group button-group">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VgButtonGroupFixed"
}
</script>

<style scoped>
.vg-button-group {
  z-index: 2;
  padding: 0 15px 60px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.vg-button-group.padding {
  visibility: hidden;
}

.vg-button-group.button-group {
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
}

.vg-button-group >>> > .vg-button {
  flex: 1;
  max-width: 75%;
  margin: 0 7px;
}
</style>